export const TOGGLE_MOBILE_SIDE_MENU            = 'TOGGLE_MOBILE_SIDE_MENU';

export const toggleMobileSideMenu = () => ({
    type: TOGGLE_MOBILE_SIDE_MENU
})



// WEBPACK FOOTER //
// ./src/Actions/ui.js